import { useState, useEffect } from "react";
import { Clock, AlertTriangle } from "lucide-react";
import { cn } from "@/lib/utils";

function parts(order, now) {
  if (!order?.accepted_at || !order?.prep_time_min) return null;
  const deadline = new Date(order.accepted_at).getTime() + order.prep_time_min * 60000;
  const diff = deadline - now;
  const overdue = diff < 0;
  const abs = Math.abs(diff);
  const m = Math.floor(abs / 60000);
  const s = Math.floor((abs % 60000) / 1000);
  return { overdue, label: `${m}:${String(s).padStart(2, "0")}` };
}

// Live prep-time countdown for accepted/preparing orders.
export function Countdown({ order, compact }) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);

  const p = parts(order, now);
  if (!p) return null;

  if (compact) {
    return (
      <span
        className={cn("inline-flex items-center gap-1 font-mono text-xs font-semibold", p.overdue ? "text-red-600 animate-pulse" : "text-blue-600")}
        data-testid="order-countdown"
      >
        <Clock className="h-3 w-3" />
        {p.overdue ? "+" : ""}
        {p.label}
      </span>
    );
  }

  return (
    <p
      className={cn(
        "mt-3 inline-flex items-center gap-1.5 text-sm rounded-md px-2.5 py-1 font-semibold tabular-nums",
        p.overdue ? "bg-red-100 text-red-700 animate-pulse" : "bg-blue-100 text-blue-700"
      )}
      data-testid="order-countdown"
    >
      {p.overdue ? <AlertTriangle className="h-3.5 w-3.5" /> : <Clock className="h-3.5 w-3.5" />}
      {p.overdue ? `Overdue by ${p.label}` : `Ready in ${p.label}`}
    </p>
  );
}
